export const GET = "GET_MARKET"
export const UPDATE = "UPDATE_MARKET"